import {
    DTOCardFormField,
} from 'app/types/form.types'
import {
    LoggerConfiguration,
    LoggerType,
} from 'app/enums/label.enums'
import {
    SizeLink, TypeLink,
} from 'app/shared-components/SkyNetLink'
import {
    LoggerFormData,
} from '../LoggerForm/LoggerForm.types'

type LoggerUpdateData = LoggerFormData & {
    loggerNumber: string,
    loggerType: LoggerType,
    isCurrentLogger: boolean
}

export default ({
    getEnumValues,
    removedOnDisabled,
    loggerNumber,
}: {
    getEnumValues: (value: Record<string, string>) => Record<string, string>,
    removedOnDisabled: boolean,
    loggerNumber: string,
}): DTOCardFormField<keyof LoggerUpdateData>[] => {
    return [
        {
            title: 'LOGGER_INFORMATION',
            className: 'loggerInformation',
            fields: [
                {
                    id: 'column1',
                    fields: [
                        {
                            name: 'loggerNumber',
                            componentName: 'SkyNetLink',
                            labelKey: 'LOGGER',
                            link: `/apps/loggers/all/edit/${loggerNumber}`,
                            type: TypeLink.INTERNAL_WITH_ICON,
                            size: SizeLink.S,
                            text: loggerNumber,
                        },
                        {
                            name: 'isCurrentLogger',
                            labelKey: 'IS_CURRENT_LOGGER',
                            componentName: 'BooleanReader',
                            disabled: true,
                        },
                    ],
                },
                {
                    id: 'column2',
                    fields: [
                        {
                            name: 'loggerType',
                            componentName: 'EnumSelector',
                            allowedValues: getEnumValues(LoggerType),
                            labelKey: 'LOGGER',
                            disabled: true,
                        },
                        {
                            name: 'isDefaultLogger',
                            labelKey: 'DEFAULT_LOGGER',
                            componentName: 'BooleanReader',
                            disabled: true,
                        },
                    ],
                },
                {
                    id: 'column3',
                    fields: [{
                        name: 'loggerPositionConfiguration',
                        disabled: true,
                        useDropdown: true,
                        componentName: 'EnumSelector',
                        allowedValues: getEnumValues(LoggerConfiguration),
                        labelKey: 'LOGGER_CONFIGURATION',
                    }],
                },
            ],
        },
        {
            title: 'PAIRING_INFORMATION',
            className: 'pairingInformation',
            fields: [
                {
                    name: 'exchangeTimestamp',
                    componentName: 'DateTimeZonedSelect',
                    disabled: true,
                    labelKey: 'EXCHANGE_TIMESTAMP',
                },
                {
                    name: 'removedOn',
                    componentName: 'DateTimeZonedSelect',
                    labelKey: 'REMOVED_ON',
                    disabled: removedOnDisabled,
                },
            ],
        },
    ]
}
